import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { runInInjectionContext } from '@angular/core';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';
import { take } from 'rxjs/operators';
import { MessageDesignBUtils } from '../../content/components/message-design-b/message-design-b.utils';
import { ObjectAction } from '../../states/object/action/object-action.actions';
import { MessageActionButtonTypeEnum } from '../../content/components/message-design-b/message.model';
import { CompogeniusNavi } from '../../services/client/navigation-service/base-routes-navigation-client.service';
import { Store } from '@ngxs/store';
import { JobCoordinationXsState } from '../../states/job-coordination/job-coordination-xs.state';

export class SseObjectEvent extends SseEventBase {

  type: SseEventType = 'object';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (this.hasEvents(resp)) {
      runInInjectionContext(this.injector, () => {
        resp.events.forEach(event => this.onEvent(resp, event));
      });
    }
  }

  private onEvent(resp: any, event: NotificationReasonEnum): void {
    this.ngZone.run(() => {
      switch (event) {
        case NotificationReasonEnum.OBJECT_DELETED: {
          this.on.orgLocationObjectReductionNeeded$.next(resp);
          break;
        }
        case NotificationReasonEnum.OBJECT_CREATED: {
          this.on.orgLocationObjectIncreaseNeeded$.next(resp);

          if (this.injector.get(Store).selectSnapshot(JobCoordinationXsState.initialized)) {
            return;
          }

          if (this.on.userRightsOfUserChangeIsLoading$.getValue() === false && this.data.getUser().id === resp.initiatingUserId) {
            this.ngZone.run(() => {
              let navigationId = resp.objectId;
              if (resp?.objectOldId) {
                navigationId = resp.objectOldId;
              }
              this.router.navigate(['/home/objekte/detail/' + navigationId]);
            });
          }

          this.on.userRightsOfUserChangeIsLoading$
            .pipe(take(1))
            .subscribe(val => {
              if (!val && this.data.getUser().id === resp.initiatingUserId) {
                this.ngZone.run(() => {
                  let navigationId = resp.objectId;
                  if (resp?.objectOldId) {
                    navigationId = resp.objectOldId;
                  }
                  this.router.navigate(['/home/objekte/detail/' + navigationId]);
                });
              }
            });

          break;
        }
        case NotificationReasonEnum.OBJECT_LOCATION_CHANGED_FROM: {
          this.on.orgLocationObjectIncreaseNeeded$.next(resp);
          break;
        }
        case NotificationReasonEnum.OBJECT_LOCATION_CHANGED_TO: {
          this.on.orgLocationObjectIncreaseNeeded$.next(resp);
          break;
        }

        case NotificationReasonEnum.OBJECTS_ACTION_EXECUTED: {
          this.on.objectActionExecuted$.next(true);
          const messageModel = MessageDesignBUtils.createObjectActionSuccess(resp.action);
          this.store.dispatch(new ObjectAction.DialogVisibility(false, resp.action));
          this.messageClientService.messages$.next(messageModel);
          this.inProgressMessageService.removeMessage(resp.demandId);
          this.on.objectActionExecuted$.next(false);
          break;
        }
        case NotificationReasonEnum.OBJECTS_ACTION_FAILED: {
          this.messageClientService.messages$.next(MessageDesignBUtils.createObjectActionError(resp.action, resp.subMessageEnum));
          this.inProgressMessageService.removeMessage(resp.demandId);
          break;
        }
        case NotificationReasonEnum.SUB_OBJECTS_ACTION_EXECUTED: {
          this.on.objectActionExecuted$.next(true);
          const messageModel = MessageDesignBUtils.createSubObjectActionSuccess(resp.action, resp.targetId);
          this.store.dispatch(new ObjectAction.DialogVisibility(false, resp.action));
          this.messageClientService.messages$.next(messageModel);
          this.inProgressMessageService.removeMessage(resp.demandId);
          this.on.objectActionExecuted$.next(false);
          break;
        }
        case NotificationReasonEnum.SUB_OBJECTS_ACTION_FAILED: {
          this.messageClientService.messages$.next(MessageDesignBUtils.createObjectActionError(resp.action, resp.subMessageEnum));
          this.inProgressMessageService.removeMessage(resp.demandId);
          break;
        }
        case NotificationReasonEnum.OBJECT_COPY_EXECUTED: {
          this.on.newObjectCopied$.next(resp.targetId);
          this.on.newSubObjectOfParent$.next(resp.parentId);
          this.inProgressMessageService.removeMessage(resp.demandId);
          const message = MessageDesignBUtils.createObjectDuplicateSuccess();
          message.actionButtonText = this.translateService.instant('DESIGN_B.OBJECTS.GO_TO_OBJECT');
          message.actionButtonType = MessageActionButtonTypeEnum.SECONDARY_BUTTON;
          message.onActionFunction = () => {
            if (resp.targetId) {
              let command;

              if (resp.hasChildObjects) {
                command = CompogeniusNavi.singletonInstance()
                  .home
                  .inventory
                  .detail
                  .children
                  .url
                  .replace('${id}', resp.targetId);
              } else {
                command = CompogeniusNavi.singletonInstance()
                  .home
                  .inventory
                  .detail
                  .basisInfo
                  .url
                  .replace('${id}', resp.targetId);
              }

              this.router.navigate([command]);
            }
          };
          this.messageClientService.messages$.next(message);
          this.on.newObjectCopied$.next(null);
          break;
        }
        case NotificationReasonEnum.OBJECT_COPY_FAILED: {
          this.messageClientService.messages$.next(MessageDesignBUtils.createObjectDuplicateError());
          break;
        }

        case NotificationReasonEnum.JOB_ROUTINE_BULK_SAVE_SUCCESS: {
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            this.messageClientService.messages$.next(MessageDesignBUtils.createJobRoutineBulkSuccess());
          }, 500);
          break;
        }
        case NotificationReasonEnum.JOB_ROUTINE_BULK_SAVE_FAILED: {
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            this.messageClientService.messages$.next(MessageDesignBUtils.saveJobRoutinesBulkFailed());
          }, 500);
          break;
        }
      }
    });
  }
}
